<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex
        pa-2
        sm12
      >
        <burndown-chart></burndown-chart>
      </v-flex>
      <v-flex
        pa-2
        sm12
      >
      <scrum-board></scrum-board>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>


import BurndownChart from '../components/BurndownChart.vue';
import ScrumBoard from '../components/ScrumBoard.vue';

export default {
  name: 'HomeView',
  components: { ScrumBoard, BurndownChart },
};
</script>
